import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { useTranslation } from "@helpers/translate";

import { InternalContent } from "@components/library";

import {
  TraderOverview,
  PerformanceStats,
  PerformanceChart,
  AssetPreferences,
  ActivityPanel,
} from "./components";

import avatarDefault from "@assets/images/default-avatar.svg";

import "./CopytraderProfile.sass";

const mockTraders = [
  {
    name: "C1ltra",
    leverage: "Long 3.35x",
    isStarred: true,
    copyTraders: 122,
    maxCopyTraders: 300,
    aum: "$21,653.40",
    daysLeading: 312,
    totalCopiers: "1,895",
    mockCopiers: "1,183",
    closedPortfolios: "2",
  },
  {
    name: "TraderX",
    leverage: "Short 2.10x",
    isStarred: false,
    copyTraders: 87,
    maxCopyTraders: 200,
    aum: "$15,200.00",
    daysLeading: 198,
    totalCopiers: "940",
    mockCopiers: "450",
    closedPortfolios: "5",
  },
  // Add more as needed...
];

export const CopytraderProfile = () => {
  const { __ } = useTranslation();
  const { id } = useParams();

  const [traderData, setTraderData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const foundTrader = mockTraders.find((t) => t.name === id);

    if (foundTrader) {
      const formattedData = {
        name: foundTrader.name,
        avatar: avatarDefault,
        stats: [
          { label: "Days Trading", value: foundTrader.daysLeading.toString() },
          {
            label: "Copiers",
            value: `${foundTrader.copyTraders}/${foundTrader.maxCopyTraders}`,
          },
          { label: "Total Copiers", value: foundTrader.totalCopiers },
          { label: "Mock Copiers", value: foundTrader.mockCopiers },
          { label: "Closed Portfolios", value: foundTrader.closedPortfolios },
        ],
      };

      setTraderData(formattedData);
    }

    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  }, [id]);

  if (isLoading) return <div>Loading...</div>;
  if (!traderData) return <div>Trader not found</div>;

  return (
    <InternalContent>
      <Helmet>
        <title>
          {__("seo.copytrader_profile")} {__("seo.divider")} {__("seo.title")}
        </title>
      </Helmet>

      <div className="copytrader-profile">
        <TraderOverview trader={traderData} />

        <div className="copytrader-profile-page__metrics-grid">
          <div className="copytrader-profile-page__left">
            <PerformanceStats />
          </div>

          <div className="copytrader-profile-page__right">
            <div className="copytrader-profile-page__chart-placeholder">
              <PerformanceChart />
            </div>
            <div className="copytrader-profile-page__chart-placeholder">
              <AssetPreferences />
            </div>
          </div>
        </div>

        <ActivityPanel />
      </div>
    </InternalContent>
  );
};
